import { useTranslation } from "next-i18next";
import React, { useCallback } from "react";
import { isChrome, isDesktop, isIOS } from "react-device-detect";

import Typography from "@/shared/components/Typography/Typography";
import { Button } from "@/components/index";

import { addQuotes } from "@/shared/utils/string/string";
import { useModalContext } from "@/shared/contexts/modal";

import styles from "./DialogInstallInstructions.module.scss";

const DialogInstallInstructions = () => {
  const { t } = useTranslation();

  const { onClose } = useModalContext();

  let body;
  if (isIOS) {
    body = (
      <ol>
        <li className={styles["item"]}>
          1. {t("sw:tapBtn")} {addQuotes(t("share"))}
          <br/>
          <img
            className={styles["image"]}
            src="/images/pwa/ios-step-1.png"
            alt="Share"
          />
        </li>
        <li className={styles["item"]}>
          2. {t("sw:tapBtn")} {addQuotes(t("sw:btnInstallIOS"))}
          <br/>
          <img
            className={styles["image"]}
            src="/images/pwa/ios-step-2.png"
            alt="Button install"
          />
        </li>
      </ol>
    );
  } else if (isDesktop && isChrome) {
    body = (
      <ol>
        <li className={styles["item"]}>
          {t("sw:tapBtn")} {addQuotes(t("install"))}
          <br/>
          <img
            className={styles["image"]}
            src="/images/pwa/chrome-step-1.png"
            alt="Install"
          />
        </li>
        <Typography variant="body3">
          ({t("sw:ifNotInstallBtn")})
        </Typography>
      </ol>
    );
  } else {
    body = (
      <ol>
        <li className={styles["item"]}>
          1. {t("sw:tapBtn")} {addQuotes(t("menu"))}
          <br/>
          <img
            className={styles["image"]}
            src="/images/pwa/ff-step-1.png"
            alt="Menu"
          />
        </li>
        <li className={styles["item"]}>
          2. {t("sw:tapBtn")} {addQuotes(t("sw:install"))}
          <br/>
          <img
            className={styles["image"]}
            src="/images/pwa/ff-step-2.png"
            alt="Button install"
          />
        </li>
      </ol>
    );
  }

  return (
    <>
      {body}
      <Button
        style={{margin: "0.9rem auto 0", minWidth: "6rem"}}
        onClick={onClose}
      >
        {t("ok")}
      </Button>
    </>
  );
};

const useDialogInstallInstructions = () => {
  const { showModal } = useModalContext();

  return useCallback(() => {
    showModal(<DialogInstallInstructions/>, {
      title: "sw:instructions",
      negativeBtn: false,
    });
  }, [showModal]);
};

export default useDialogInstallInstructions;
